import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TraceClassDecorator } from "@sentry/angular";
import { ProviderStateService } from "src/app/services/provider-state.service";
import { UtilitiesService } from "src/app/utilities/utilities.service";

@Component({
    selector: "app-invalid-link",
    templateUrl: "./invalid-link.component.html",
    styleUrls: ["./invalid-link.component.css"],
})
@TraceClassDecorator()
export class InvalidLinkComponent implements OnInit {
    seconds: any = { leftTime: 5, format: "s" };
    slug: string = "";
    logo_url: string = "";
    constructor(
        private router: Router,
        private readonly utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) { }

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.logo_url = this.providerstateService.getLogoUrl();
        setTimeout(() => {
            this.router.navigate(["/" + this.slug + "/"]);
        }, 5000);
    }

    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }
}
